import { Link } from "react-router-dom";
import Logo from "./../../assets/img/logo-portal-temp-1.png";
import useAuth from "../../contexts/auth";
import { Navbar, Nav, NavDropdown, Button, Modal, Row, Col, Dropdown, Form, FormControl } from "react-bootstrap";
import { useState, useEffect } from "react";
import useWindowSize from "../../hooks/useWindowSize";
import { FaUserCircle } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import AddNewForm from "../AddNewForm";
import { useSearch } from "../../contexts/SearchContext";
import {
  Menu,
  MenuItem,
  ProSidebar,
  SidebarContent,
  SubMenu,
} from "react-pro-sidebar";
import "./style.scss";

import useCategories from '../../hooks/useCategories';
import { useParams, useHistory } from "react-router-dom";
export default function NavBar() {
  const { user, logout } = useAuth();
  const { width } = useWindowSize();
  const [toggled, setToggled] = useState(false);
  const closeSidebar = () => setToggled(false);
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const [lastCategory, setLastCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const { searchTerm, setSearchTerm } = useSearch();
  const categories = useCategories();
  const CategoriesMenuInline = () => {
    const history = useHistory();


    const handleCategorySelect = (slug) => {
      history.push(`/categoria/${slug}`);
      setLastCategory(slug); // Se tiver esse state ainda
    };

    return (
      <Nav className="categories-inline-menu">


        {categories.map(category => (
          <Nav.Item key={category.id}>
            <Nav.Link onClick={() => handleCategorySelect(category.slug)}>
              {category.name}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    );
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setTimeout(() => {
      window.location.reload();
    }, 1000); // Aguarda 1 segundo antes de recarregar a página
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    // O termo debounced já está sendo gerenciado no contexto, não é necessário reagir aqui
    console.log("Form submitted with search term:", searchTerm);
  };

  function ModalAddProduct(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <span className="text-primary">Adicionar Noticia</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddNewForm onSubmit={props.onHide} />
        </Modal.Body>
      </Modal>
    );
  }

  const renderUnlogged = () => {
    return (
      <Nav className="ml-auto">
        <Nav.Link as={Link} to="/entrar">
          Entrar
        </Nav.Link>
      </Nav>
    );
  };
  const renderEntrepreneurSidebar = () => {
    return (
      <SubMenu title="Painel das Ofertas do Editor" defaultOpen>


        <MenuItem>
          <Link to="/editor/news" onClick={closeSidebar}>
            Minhas Noticias
          </Link>
        </MenuItem>

      </SubMenu>
    );
  };
  const renderAdminSidebar = () => {
    return (
      <SubMenu title="Painel do Admin"  >
        <MenuItem >
          <Link to="/admin/dashboard" onClick={closeSidebar}>
            Dashboard
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="/admin/usuarios" onClick={closeSidebar}>
            Usuários
          </Link>
        </MenuItem>

        <MenuItem>
          <Link to="/admin/localidades" onClick={closeSidebar}>
            Localidades
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="/admin/categorias" onClick={closeSidebar}>
            Categorias
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="/admin/news" onClick={closeSidebar}>
            Noticias
          </Link>
        </MenuItem>
        <MenuItem>
          <Link to="/admin/ribbon-badges" onClick={closeSidebar}>
            Todos os Emblemas
          </Link>
        </MenuItem>

        <MenuItem>
          <Link to="/admin/tipo-publicacao" onClick={closeSidebar}>
            Tipo de publicação
          </Link>
        </MenuItem>


        <MenuItem>
          <Link to="/admin/comentarios" onClick={closeSidebar}>
            Comentários
          </Link>
        </MenuItem>

        <MenuItem>
          <Link to="/admin/tutoriais" onClick={closeSidebar}>
            Tutoriais
          </Link>
        </MenuItem>




      </SubMenu>
    );
  };
  const renderUser = () => {
    return (
      <NavDropdown
        id="basic-nav-dropdown"
        title={
          <span className="align-self-center">
            <FaUserCircle className="text-secondary" size={"22"} />
            {width > 450 && <span className="ml-2">{user.name}</span>}
          </span>
        }
        alignRight
      >
        <NavDropdown.Item to="/conta" as={Link} onClick={closeSidebar}>
          Minha Conta
        </NavDropdown.Item>
        {user.type !== "admin" && (
          <>

          </>
        )}
        <NavDropdown.Item onClick={logout}>Sair</NavDropdown.Item>
      </NavDropdown>
    );
  };
  const CategoriesMenu = () => {
    const navigate = useHistory(); // Use useNavigate para v6


    const handleCategorySelect = (id, isSubCategory, path) => {

      navigate.push(path);  // Ajuste para v6


      setLastCategory(id);


    };
    const resetSelection = () => {
      setLastCategory(null);

      navigate.push('/');

    };

    return (



      categories.map((category) => (
        <MenuItem key={category.id} onClick={() => handleCategorySelect(category.slug, false, `/categoria/${category.slug}`)}>
          {category.name}
        </MenuItem>
      ))


    );
  };
  return (
    <>
      <div>
        <Navbar fixed="top" bg="primary" variant="dark">
          <Navbar.Brand as={Link} to="/" onClick={closeSidebar}>
            <img
              src={Logo}
              alt="Logo"
              width="150px"
              className="mx-2 d-flex align-self-center"
            />
          </Navbar.Brand>
          {width > 992 && (
            <Nav className="mr-auto">
              <Nav.Link as={Link} to="/" onClick={closeSidebar}>
                Últimas notícias
              </Nav.Link>
              <Nav.Link as={Link} to="/analises" onClick={closeSidebar}>
                Análises
              </Nav.Link>
              <CategoriesMenuInline />

              <Nav.Link as={Link} to="/ofertas" onClick={closeSidebar}>
                Ofertas
              </Nav.Link>

              <Nav.Link as={Link} to="/sobre" onClick={closeSidebar}>
                Sobre
              </Nav.Link>
              {user && user.type !== "client" && (
                <Nav.Link
                  as={Link}
                  to={user.type === "admin" ? "/admin" : "/editor"}
                >
                  Painel
                </Nav.Link>
              )}
              {user && user.type !== "client" && (
                <Nav.Link onClick={handleOpenModal}>Adicionar Noticia</Nav.Link>
              )}
            </Nav>

          )}
          {width > 992 && (
            <Form inline className="ml-auto" onSubmit={handleSearchSubmit}>
              <FormControl
                type="text"
                placeholder="Buscar"
                className="mr-sm-2 novo"
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)} // Atualiza searchTerm a cada alteração
              />
            </Form>

          )}
          {width < 992 && (
            <Button
              size="sm"
              className="ml-auto"
              onClick={() => setToggled((state) => !state)}
            >
              <GiHamburgerMenu />
            </Button>
          )}
          {user && <Nav xs="auto">{renderUser(user.type, width)}</Nav>}
          {!user && width > 992 && <Nav xs="auto">{renderUnlogged()}</Nav>}

        </Navbar>
        <div className="yellow-strip" ></div>

        {width < 992 && (
          <ProSidebar
            breakPoint="lg"
            toggled={toggled}
            onToggle={(value) => {
              setToggled(value);
            }}
          >
            <SidebarContent style={{ background: "#0051b7" }}>
              <Menu >
                <MenuItem>
                  <Link to="/" onClick={closeSidebar}>
                    Últimas notícias
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/analises" onClick={closeSidebar}>
                    Análises
                  </Link>
                </MenuItem>

                <CategoriesMenu />

                <MenuItem>
                  <Link to="/ofertas" onClick={closeSidebar}>
                    Ofertas
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link to="/sobre" onClick={closeSidebar}>
                    Sobre
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Form inline onSubmit={handleSearchSubmit} className="ml-auto">
                    <FormControl
                      type="text"
                      placeholder="Buscar"
                      className="search-input"
                      value={searchTerm}
                      onChange={e => setSearchTerm(e.target.value)} // Atualiza searchTerm a cada alteração
                    />
                  </Form>
                </MenuItem>
                {user && user.type !== "client" && (
                  <MenuItem onClick={handleOpenModal}>Adicionar Noticia</MenuItem>
                )}
                {user &&
                  user.type === "editor" &&
                  renderEntrepreneurSidebar()}
                {user && user.type === "admin" && renderAdminSidebar()}
                {!user}
                {!user && (
                  <MenuItem>
                    <Link to="/entrar" onClick={closeSidebar}>
                      Entrar
                    </Link>
                  </MenuItem>
                )}
              </Menu>
            </SidebarContent>
          </ProSidebar>
        )}
      </div>
      <ModalAddProduct
        show={showModal}
        onHide={handleCloseModal}
      />
    </>
  );
}
